import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacabsonrentinpune() {



const cardData = {
  keyword: "  Innova Cabs on Rent in Pune  ",

"headingDescription": "Innova Cabs on Rent in Pune provide a safe, spacious, and comfortable travel solution for families, groups, and corporate clients. SRS Cab Service offers well-maintained Innova vehicles with professional drivers, ensuring timely pickups, smooth rides, and hassle-free travel across Pune. Perfect for airport transfers, city tours, weekend trips, and corporate travel, our service combines flexible booking, transparent pricing, and 24/7 customer support to make every journey convenient and enjoyable.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is an iconic fort in Pune, representing Maratha architecture and history. Travelers using Innova Cabs on Rent often visit this site to explore its grand structures and cultural significance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historical landmark connected to India’s freedom struggle. Visitors using Innova Cabs on Rent can admire its beautiful gardens and learn about its rich history."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is famous for its scenic hill views and trekking trails. Travelers renting an Innova Cab often include this destination for adventure and sightseeing experiences."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is a spiritual and cultural hub in Pune. Visitors using Innova Cabs on Rent frequently stop here to experience devotion and local traditions."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine dedicated to Lord Shiva. Travelers using Innova Cabs on Rent enjoy the peaceful surroundings and historical architecture."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases a variety of Indian artifacts and cultural treasures. Visitors renting Innova Cabs explore Pune’s artistic and historical heritage at this museum."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune and historical temples. Travelers using Innova Cabs on Rent often climb the hill to enjoy sightseeing and peaceful surroundings."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a tranquil spot ideal for relaxation and photography. Groups renting Innova Cabs often visit this destination to enjoy natural beauty and serenity."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a Japanese-style landscaped garden perfect for calm walks. Travelers using Innova Cabs on Rent enjoy its lush greenery and serene environment."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace associated with Chhatrapati Shivaji Maharaj. Visitors using Innova Cabs on Rent often explore this landmark to learn about Pune’s rich history."
  }
],



services: [
{
name: "Innova Taxi Near Me in Pune",
description: "Innova taxi near me in Pune offers quick and convenient local booking options. Customers can find nearby cabs for instant travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Book nearby Innova taxis easily in Pune."
},
{
name: "Innova Crysta Taxi in Pimpri Chinchwad",
description: "Innova Crysta taxi in Pimpri Chinchwad provides premium travel for city and outstation trips. Customers can book spacious vehicles easily. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova Crysta taxis."
},
{
name: "Innova Cab Rental for Local and Outstations",
description: "Innova cab rental for local and outstations offers flexible travel solutions. Customers can book vehicles for city rides and long-distance trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Choose Innova rentals for all travel needs."
},
{
name: "Innova on Rent for Outstation",
description: "Innova on rent for outstation provides reliable long-distance travel options. Customers can book vehicles for tours and trips. Professional drivers ensure safe highway journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova outstation rentals."
},
{
name: "Innova Outstation Rental",
description: "Innova outstation rental offers convenient travel for long-distance journeys. Customers can book vehicles for flexible travel plans. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Choose Innova outstation rentals easily."
},
{
name: "8 Seater Innova on Rent in Pune",
description: "8 seater Innova on rent in Pune provides spacious travel for families and groups. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 8 seater Innova rentals."
},
{
name: "Hire Innova for Outstation",
description: "Hire Innova for outstation offers convenient travel for long-distance trips. Customers can hire vehicles for tours and business travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Hire Innova cars easily for outstation travel."
},
{
name: "Innova 7 Seater Taxi in Pune",
description: "Innova 7 seater taxi in Pune offers comfortable travel for small groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 7 seater Innova taxis."
},
{
name: "Innova Cab for Rent",
description: "Innova cab for rent provides flexible travel solutions for all needs. Customers can rent vehicles for city and long-distance trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Rent Innova cabs easily."
},
{
name: "Innova Cabs Near Me Viman Nagar",
description: "Innova cabs near me Viman Nagar offer nearby booking options for customers. Users can find cabs easily for quick travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book Innova cabs near Viman Nagar easily."
},
{
name: "Innova for Rent Outstation in Kharadi",
description: "Innova for rent outstation in Kharadi provides reliable travel for long-distance trips. Customers can book vehicles for tours and business travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily from Kharadi with Innova."
},
{
name: "Innova Hire for Outstation",
description: "Innova hire for outstation offers convenient travel for extended journeys. Customers can hire vehicles for tours and family trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Hire Innova cars easily for outstation travel."
},
{
name: "Innova Outstation Cab from Pune",
description: "Innova outstation cab from Pune provides dependable travel for long-distance trips. Customers can book vehicles for flexible journeys. Professional drivers ensure safe highway travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova outstation cabs."
},
{
name: "Innova Rental for Outstation in Pimpri Chinchwad",
description: "Innova rental for outstation in Pimpri Chinchwad offers convenient travel options. Customers can book vehicles for long-distance trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova rentals."
},
{
name: "Pune to Mahabaleshwar Innova Cab",
description: "Pune to Mahabaleshwar Innova cab offers comfortable travel for hill station trips. Customers can enjoy scenic journeys. Professional drivers ensure safe ghat road travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Mahabaleshwar with Innova."
},
{
name: "Pune to Shirdi Innova Cab",
description: "Pune to Shirdi Innova cab provides convenient travel for temple visits. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Shirdi with Innova."
},
{
name: "Pune to Shirdi Innova Cab Booking",
description: "Pune to Shirdi Innova cab booking offers easy reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your Innova cab easily."
},
{
name: "Pune Airport to Shirdi Car Rental",
description: "Pune Airport to Shirdi car rental provides direct travel from airport to temple destination. Customers can book vehicles for quick transfers. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily from airport to Shirdi."
},
{
name: "Pune to Shani Shingnapur Innova Cab",
description: "Pune to Shani Shingnapur Innova cab offers convenient travel for temple visits. Customers can book vehicles for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova services."
},
{
name: "Pune to Goa Innova Cab",
description: "Pune to Goa Innova cab offers comfortable long-distance travel for vacations. Customers can enjoy spacious rides for beach trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Goa with Innova."
},
{
name: "Pune to Goa Innova Cab Booking",
description: "Pune to Goa Innova cab booking provides quick reservation options for travelers. Customers can book cabs online easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your Innova cab to Goa easily."
},
{
name: "Pune to Lonavala Innova Cab",
description: "Pune to Lonavala Innova cab offers comfortable travel for short trips. Customers can book vehicles for group outings. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Lonavala with Innova."
},
{
name: "Pune to Bhimashankar Innova Cabs",
description: "Pune to Bhimashankar Innova cabs provide reliable travel for temple visits. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe ghat travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova services."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab offers convenient intercity travel between two major cities. Customers can book vehicles for business and leisure trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova cab services."
}
],

tableData: [
["Innova Taxi Near Me in Pune","Innova Crysta Taxi in Pimpri Chinchwad"],
["Innova Cab Rental for Local and Outstations","Innova on Rent for Outstation"],
["Innova Outstation Rental","8 Seater Innova on Rent in Pune"],
["Hire Innova for Outstation","Innova 7 Seater Taxi in Pune"],
["Innova Cab for Rent","Innova Cabs Near Me Viman Nagar"],
["Innova for Rent Outstation in Kharadi","Innova Hire for Outstation"],
["Innova Outstation Cab from Pune","Innova Rental for Outstation in Pimpri Chinchwad"],
["Pune to Mahabaleshwar Innova Cab","Pune to Shirdi Innova Cab"],
["Pune to Shirdi Innova Cab Booking","Pune Airport to Shirdi Car Rental"],
["Pune to Shani Shingnapur Innova Cab","Pune to Goa Innova Cab"],
["Pune to Goa Innova Cab Booking","Pune to Lonavala Innova Cab"],
["Pune to Bhimashankar Innova Cabs","Pune to Mumbai Innova Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable & Spacious Innova Travel",
    WhyChoosedescription: "SRS Cab Service offers Innova cabs on rent in Pune with spacious seating, smooth suspension, and excellent comfort, making it perfect for family trips and group travel."
  },
  {
    WhyChooseheading: "Affordable Innova Cab Rental Pricing",
    WhyChoosedescription: "We provide budget-friendly Innova rental in Pune with transparent pricing. Rates generally start from ₹14 to ₹18 per km depending on travel type and duration."
  },
  {
    WhyChooseheading: "Best for Outstation & Local Travel",
    WhyChoosedescription: "Innova cabs are ideal for Pune to Mumbai, Shirdi, Nashik, Mahabaleshwar, and airport transfers, offering reliable and comfortable long-distance travel."
  },
  {
    WhyChooseheading: "24/7 Innova Cab Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Innova cab bookings in Pune, ensuring convenient travel anytime including late-night and early morning rides."
  },
  {
    WhyChooseheading: "Multiple Seating Options Available",
    WhyChoosedescription: "We offer 6+1 and 7+1 seating Innova cabs suitable for families, corporate travel, and small group tours with ample luggage space."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "Our trained and experienced drivers are familiar with Pune city routes and highways, ensuring safe, smooth, and stress-free travel."
  },
  {
    WhyChooseheading: "Clean & AC Well-Maintained Vehicles",
    WhyChoosedescription: "All Innova cabs are fully air-conditioned, regularly serviced, and cleaned to provide a hygienic and comfortable travel experience."
  },
  {
    WhyChooseheading: "Trusted Innova Cab Service in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for Innova cabs on rent in Pune due to reliable service, affordable pricing, and high customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide Innova cabs on rent in Pune?", answer: "Yes, SRS Cab Service offers Innova cab rental in Pune for local, airport, and outstation travel." },
  { question: "What is the price of Innova cab per km in Pune?", answer: "Innova cab rental in Pune typically starts from ₹14 to ₹18 per km depending on the trip and duration." },
  { question: "Is Innova available for outstation trips?", answer: "Yes, Innova cabs are ideal for outstation travel like Mumbai, Shirdi, Nashik, Goa, and more." },
  { question: "How many passengers can travel in Innova?", answer: "Innova cabs are available in 6+1 and 7+1 seating options suitable for families and groups." },
  { question: "Is Innova suitable for airport transfer?", answer: "Yes, Innova cabs are perfect for Pune Airport and Mumbai Airport transfers with luggage space." },
  { question: "Is Innova cab available 24/7?", answer: "Yes, our service operates 24 hours a day for flexible booking." },
  { question: "Are Innova vehicles air-conditioned?", answer: "Yes, all Innova cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book Innova cab online?", answer: "Yes, you can easily book Innova cabs on rent in Pune online or via phone." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip Innova cab services." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Patil",
    feedback:
      "Booked Innova cab from SRS for Shirdi trip. Very comfortable and smooth journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Sharma",
    feedback:
      "Best Innova cab rental in Pune. Clean car, professional driver, and great service.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Cabs on Rent in Pune | SRS Cab",
  "description": "SRS Cab offers Innova cabs on rent in Pune for local and outstation travel. Hire 7 and 8 seater Innova taxis for airport transfers, corporate trips, family tours, and long-distance travel. Available in Pimpri Chinchwad, Viman Nagar, Kharadi, and across Pune with 24x7 online booking and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Innova Cabs on Rent in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Hire Innova cabs on rent in Pune with SRS Cab. 7 & 8 seater taxis for local and outstation trips, airport transfers, corporate travel, and family tours. Available across Pune with 24x7 online booking and affordable fares." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacabsonrentinpune;